import GamesRecordResultContent from "../GamesRecordResultContent";
import GamesSuccessResultContent from "../GamesSuccessResultContent";
import GamesResultsBottomBar from "../../../bars/games/GamesResultsBottomBar";
import GamesResultsLayout from "../../../layouts/games/GamesResultsLayout";
import GamesLooseResultContent from "../GamesLooseResultContent";
import {kRelativeSumLists} from "../../../../constants/lists";
import {kGamesNumbers} from "../../../../constants/numbers";

export default function RelativeSumResults({isLost, finalScore, lastRelativeSum, lastAnswer, onRetryPressed}) {
    // Used in MultiplicationGameScreen to display loose, success of
    // record related content

    // BUILD
    return (
        <div className={"animate-appearSlow bg-backgroundLight3 w-full h-full flex flex-col justify-center items-center"}>
            <GamesResultsLayout>
                {isLost
                    ? <GamesLooseResultContent
                        lastQuestion={lastRelativeSum}
                        finalScore={finalScore}
                        lastAnswer={lastAnswer}
                        advicesList={kRelativeSumLists.looseAdvices} />
                    : finalScore > kGamesNumbers.relativeSumRecord
                        ? <GamesRecordResultContent finalScore={finalScore}
                                                    advicesList={kRelativeSumLists.recordAdvices} />
                        : <GamesSuccessResultContent finalScore={finalScore} /> }
                <GamesResultsBottomBar
                    onRetryPressed={onRetryPressed} />
            </GamesResultsLayout>
        </div>
    );
}